import Notification from '@anwb/poncho/components/notification';
import { getCurrentStepNumber } from 'utils/navigation';

export const ServicesHealthErrorNotification = () => {
	const currentStepNumber = getCurrentStepNumber();

	const errorMessage =
		currentStepNumber === 3
			? 'Probeer het later opnieuw. Onze excuses voor het ongemak.'
			: 'Probeer het later opnieuw en vernieuw deze pagina. Onze excuses voor het ongemak.';

	return (
		<Notification
			title="Door een technische storing is het tijdelijk niet mogelijk om online een aanvraag te doen"
			variant="error"
		>
			{errorMessage}
		</Notification>
	);
};
